module.exports = __webpack_public_path__ + "static/img/01_header_bg.e03423c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/01_header_bg.jpg
// module id = Y/A5
// module chunks = 13